import React, { useState, useMemo } from "react";
import PageHeader from "../components/PageHeader";
import { PROJECTS, CATEGORIES } from "../lib/data";

export default function Projects() {
  const [active, setActive] = useState("All");

  const filtered = useMemo(
    () => (active === "All" ? PROJECTS : PROJECTS.filter((p) => p.category === active)),
    [active]
  );

  return (
    <>
      <PageHeader
        eyebrow="Projects"
        title={<span className="text-yellow-400">A selection of our recent work.</span>}
        sub="Bank branches, insurance offices, financial institutions and retail stores executed across India."
        image="https://images.unsplash.com/photo-1556742111-a301076d9d18?auto=format&fit=crop&w=2400&q=85"
      />

      <section className="bg-[#FAFAFA] py-20 lg:py-24">
        <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
          <div className="flex flex-wrap gap-3 mb-12">
            {CATEGORIES.map((c) => (
              <button
                key={c}
                onClick={() => setActive(c)}
                data-testid={`filter-${c.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
                className={`px-5 py-3 text-sm tracking-wide border transition-all duration-300 ${
                  active === c
                    ? "bg-[#0A192F] text-white border-[#0A192F]"
                    : "bg-white text-[#0A192F] border-[#E2E8F0] hover:border-[#C5A059] hover:text-[#C5A059]"
                }`}
              >
                {c}
              </button>
            ))}
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {filtered.map((p) => (
              <article
                key={p.id}
                data-testid={`project-${p.id}`}
                className="group bg-white border border-[#E2E8F0] hover:border-[#C5A059] transition-colors duration-500"
              >
                <div className="img-zoom aspect-[16/10]">
                  <img src={p.image} alt={p.title} className="w-full h-full object-cover" />
                </div>
                <div className="p-5">
                  <p className="text-xs uppercase tracking-widest text-[#C5A059]">{p.category}</p>
                  <h3 className="font-heading text-lg font-semibold text-[#0A192F] mt-2">{p.title}</h3>
                  <p className="text-sm text-[#475569] mt-1">{p.location}</p>
                </div>
              </article>
            ))}
          </div>

          {filtered.length === 0 && (
            <div data-testid="projects-empty" className="bg-white border border-[#E2E8F0] py-20 text-center text-[#475569]">
              No projects to show in this category.
            </div>
          )}
        </div>
      </section>
    </>
  );
}
